import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function Territory() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate();

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em',
              minHeight: '72vh', height: 'auto'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Territory & Rights
                </div>

                <div className="infoDesc"> 
                N3RVE us a flexible platform built for accommodating different artists at every stage of their career. 
                </div>
                <div className="infoDesc"> 
                <br/>With N3RVE you have the ease of distributing your music all over the world, circumventing various territory restrictions that may otherwise limit your musics reach.
                </div>
                <div className="infoDesc"> 
                <br/>Our platform flexibility is multifaceted, and can be used to augment deals that you currently have by adding additional territories around the globe
                </div>

                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default Territory;